import { createSlice } from "@reduxjs/toolkit";
import {
  validateFileContent,
  validateFileSize,
  validateFileType,
  validateThatFileToAddNotExceedMaxFilesNumber,
  validateThatFileToAddNotExistingInAddedFiles,
} from './FileValidator';
import { addFile } from "../complaintPosition/ComplaintPositionSlice";

const initialState = {
  files: [],
};

export const afterFileParseCallback = (parsedFile, filesTargetName) => {
  try {
    validateFileContent(parsedFile.base64);
    return (dispatch) => {
      dispatch(addFile(parsedFile, filesTargetName)); // Wywołanie odpowiedniej akcji w Redux Store
    };
  } catch (error) {
    throw new Error("Błąd podpinania pliku", error);
  }
};

export function unparseFile(file, filesTargetName) {
  return (dispatch, getState) => {
    const files = getState().complaintPosition.files;
    const purchaseProve = getState().complaintPosition.purchaseProve;
    try {
      validateThatFileToAddNotExceedMaxFilesNumber(files);
      validateFileType(file);
      validateThatFileToAddNotExistingInAddedFiles(file, files);
      validateThatFileToAddNotExistingInAddedFiles(file, purchaseProve);
      validateFileSize(file, 5242880);
      parseFile(file, afterFileParseCallback, dispatch, filesTargetName);
    } catch (error) {
      throw new Error("Błąd podpinania pliku", error.message);
    }
  };
}

function parseFile(file, callback, dispatch, filesTargetName) {
  let fileReader = new FileReader();
  fileReader.onload = function (e) {
    dispatch(callback(
      { name: file.name, base64: e.target.result },
      filesTargetName
    ));
  };
  try {
    fileReader.readAsDataURL(file);
  } catch (error) {
    throw new Error("Wystąpił błąd podczas podpinania pliku.");
  }
}

const fileSlice = createSlice({
  name: "files",
  initialState,
  reducers: {
    setFile: (state, action) => {
      const filesToAdd = action.payload;
      filesToAdd.forEach((file) => {
        state.files.push(file);
      });
    },
    removeFile: (state, action) => {
      const { index } = action.payload;
      state.files.splice(index, 1);
    },
    clearFiles: (state)=>{
      state.files = [];
    }

  },
});

export const { setFile, removeFile,clearFiles } = fileSlice.actions;
export default fileSlice.reducer;